<template>
  <div class="text-medium" :key="kr.id" :data-kr-id="kr.id" :data-goal-id="kr.goalId">
    <div class="key-result d-flex position-relative">
      <collapse-caret
        :size="20"
        class="collapse-caret"
        :expanded="isExpanded"
        @click="isExpanded = !isExpanded"
      />
      <i class="kr-icon flex-shrink-0"></i>
      <span class="pl-2 kr-title" v-no-capture>{{ kr.title }}</span>
      <div class="move-btn-wrapper position-absolute flex-center">
        <b-button
          class="text-nowrap"
          @click="$emit('move', { goalId: kr.goalId, keyResultId: kr.id })"
          pill
          variant="primary"
          size="sm"
          >Move to this KR
        </b-button>
      </div>
    </div>
    <b-collapse class="initiatives-list" v-model="isExpanded">
      <div class="message-section text-secondary" v-if="initiatives && initiatives.length === 0">
        This KR does not have any initiatives
      </div>
      <move-to-initiatives-section
        :initiatives="initiatives"
        @fetch="fetchInitiatives"
        :loading-state="initiativeLoadingState"
        @move="payload => $emit('move', { ...payload, goalId: kr.goalId, keyResultId: kr.id })"
        v-else
      />
    </b-collapse>
  </div>
</template>

<script>
import CollapseCaret from '@/components/CollapseCaret'
import MoveToInitiativesSection from '@/components/initiative/MoveToInitiativesSection.vue'
import { LoadingState } from '@/constants/common'
import { BButton, BCollapse } from 'bootstrap-vue'
import { mapActions } from 'vuex'

/**
 * This provides a KRRow with a CTA (Move to this KR), click of which emits an event with related krId and goalId as payload.
 * If prop - initiative is a Task, KR becomes expandable. Now user can select the initiative to which movement is required.
 */
export default {
  name: 'MoveInitiativeKrRow',
  props: ['kr'],
  components: {
    MoveToInitiativesSection,
    BButton,
    CollapseCaret,
    BCollapse
  },
  data() {
    return {
      isExpanded: false,
      initiatives: null,
      LoadingState,
      initiativeLoadingState: null
    }
  },
  computed: {},
  methods: {
    ...mapActions(['getInitiatives']),
    async fetchInitiatives() {
      this.initiativeLoadingState = LoadingState.LOADING
      const { organizationId: orgId, id: krId } = this.kr
      try {
        const response = await this.getInitiatives({
          orgId,
          krId,
          hasParent: false
        })
        this.initiatives = response.results
        this.initiativeLoadingState = LoadingState.LOADED
      } catch (e) {
        this.initiativeLoadingState = LoadingState.ERRORED
      }
    }
  },
  mounted() {},
  watch: {
    isExpanded(expanded) {
      if (expanded && !this.initiatives && this.initiativeLoadingState !== LoadingState.LOADING) {
        this.fetchInitiatives()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.key-result {
  padding: 0 8px 0 24px;
  border-radius: 16px;
  overflow: hidden;
}

.kr-icon {
  margin-top: 11px;
}

.key-result:hover,
.initiative:hover {
  background-color: $selectionColor;
}

.kr-title {
  padding: 6px 0;
}

.move-btn-wrapper {
  right: 0;
  top: 0;
  bottom: 0;
  background-color: $documentColor;
  font-weight: 600;
  display: none;
  padding: 0 5px 0 4px;

  /deep/ button {
    padding: 1px 12px;
  }
}

.key-result {
  &:hover .move-btn-wrapper {
    background-color: $selectionColor;
    display: flex;
    transform: translateX(0);
  }
}

.collapse-caret {
  margin-right: 8px;
  margin-top: 6px;
}

.initiatives-list {
  margin-left: 34px;
  padding: 6px 0;
}

.message-section {
  padding-left: 36px;
  padding-bottom: 18px;
}
</style>
